export const getMilitaryStatuses = (): string[] => ([
    'executed',
    'not executed',
    'released'
]);
